module.exports = __webpack_public_path__ + "media/assets/icons/arrow-left-right-043ef438136e7763a22aa418f48f537a.svg";